import {
  captionImageSrc,
  getCaptionImage,
} from "@poppycock/shared";

/** Shared photo + tease for caption rounds. */
export function CaptionPrompt({
  imageId,
  category,
  compact = false,
}: {
  imageId: string;
  category?: string;
  /** Smaller image for guessing / reveal chrome. */
  compact?: boolean;
}) {
  const meta = getCaptionImage(imageId);
  const src = captionImageSrc(imageId);
  const tease = category || meta?.tease || "Write a caption";
  const alt = meta?.alt ?? "Caption contest photo";

  return (
    <div>
      <p className="mb-1 text-xs tracking-wide text-[var(--color-accent)] uppercase">
        Caption this
      </p>
      <p
        className={`font-semibold tracking-tight ${
          compact ? "mb-3 text-base" : "mb-4 text-xl sm:text-2xl"
        }`}
      >
        {tease}
      </p>
      {src ? (
        <div className="overflow-hidden rounded-xl border border-white/10 bg-black/30">
          <img
            src={src}
            alt={alt}
            className="mx-auto block h-auto w-full object-contain"
            decoding="async"
            loading={compact ? "lazy" : "eager"}
          />
        </div>
      ) : (
        <div className="flex aspect-square max-h-64 items-center justify-center rounded-xl border border-dashed border-white/15 bg-black/20 text-sm text-[var(--color-muted)]">
          Image missing ({imageId})
        </div>
      )}
    </div>
  );
}
